import { Link, useNavigate, useParams } from "react-router-dom";
import { Box, Button, Container, Grid2, Typography, TextField, Card, CardContent, Alert } from '@mui/material';
import { useAuth } from '../AuthContext';
import { useCallback, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export default function ResetPassword() {
  const params = useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const [formLoading, setFormLoading] = useState();
  const [formError, setFormError] = useState();
  const [formSuccess, setFormSuccess] = useState();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    const email = formData.get("email");
    const token = await executeRecaptcha('beta');

    setFormSuccess(false);
    setFormLoading(true);
    setFormError(null);

    auth.request('/api/user/reset-request', { email, token }).then((resp) => {
      console.log(resp);
      setFormSuccess(true);
      setFormLoading(false);
    }).catch(error => {
      console.log('error', error);
      setFormLoading(false);
      setFormError(error.message);
    });

  }, [executeRecaptcha]);

  if (params.token) {
    return (
      <Box><Typography>Reset Password</Typography></Box>
    )
  }

  return (
    <Container maxWidth="sm" sx={{ p: 3 }}>
      <Typography variant="h3">Reset Password</Typography>
      <Typography sx={{ my: 3 }}>Enter the email associated with your OpenGolfSim account to start the password reset process.</Typography>

      {formSuccess ? (
        <Box>
          <Alert severity="success">Check your email for a password reset link. If we found your email on file, you should receive the email shortly.</Alert>
        </Box>
      ) : (
        <>
          <form onSubmit={handleSubmit}>
            <Grid2 container direction="column" spacing={3}>
              <Grid2>
                <TextField disabled={formLoading} name="email" label="Email" fullWidth required />
              </Grid2>
            </Grid2>
            <Grid2 container sx={{ mt: 2 }}>
              <Grid2>
                <Button disabled={formLoading} type="submit" color="primary" variant="outlined">Reset Password</Button>
              </Grid2>
            </Grid2>
          </form>

          {
            formError ? (
              <Alert severity="error">{formError}</Alert>
            ) : null
          }
      
        </>
      )}
      
    </Container>
  );
}
